module.exports = __webpack_public_path__ + "static/media/LX.6c251958.png";